import { getTeamUrl } from 'Common';

export default () => async (dispatch, getState) => {

  const { id } = getState().screens.ProjectView.project;

  window.open(getTeamUrl(`projects/${id}/target_costs_pdf`, 'exports'));

}
